import { SingleToolHeader } from '@quicktools/shared-components';
import { memo } from 'react';

import analytics from '../../services/analytics';
import { TOOL_NAME } from '../../configs';

function Header() {
  return <SingleToolHeader toolName={TOOL_NAME} analytics={analytics} />;
}

export default memo(Header);
